/* eslint-disable */
require('./capital_1')
require('./capital_2')
require('./capital_3')
require('./citadel')
require('./corvette_1')
require('./corvette_2')
require('./corvette_3')
require('./dome_academy')
require('./dome_defense_1')
require('./dome_defense_2')
require('./dome_happiness')
require('./dome_ideo')
require('./dome_industries')
require('./dome_mobility')
require('./dome_pop')
require('./fighter_1')
require('./fighter_2')
require('./fighter_3')
require('./fighter_4')
require('./frame_patent')
require('./frigate_1')
require('./frigate_2')
require('./frigate_3')
require('./frigate_4')
require('./infra_dome_1')
require('./infra_dome_2')
require('./infra_dome_3')
require('./infra_dome_4')
require('./infra_dome_5')
require('./infra_open_1')
require('./infra_open_2')
require('./infra_open_3')
require('./infra_open_4')
require('./infra_open_5')
require('./infra_orbital_1')
require('./infra_orbital_2')
require('./infra_orbital_3')
require('./infra_orbital_4')
require('./infra_orbital_5')
require('./merge_corvette_1')
require('./merge_corvette_2')
require('./merge_fighter_1')
require('./merge_fighter_2')
require('./merge_fighter_3')
require('./merge_fighter_corvette')
require('./merge_frigate_1')
require('./open_credit')
require('./open_defense')
require('./open_happiness')
require('./open_ideo')
require('./open_industries')
require('./open_intel')
require('./open_island')
require('./open_lift')
require('./open_mobility')
require('./open_research')
require('./orbital_credit')
require('./orbital_defense')
require('./orbital_happiness')
require('./orbital_hypergate')
require('./orbital_mobility')
require('./orbital_prod')
require('./orbital_radar')
require('./orbital_research')
require('./shipyard_1')
require('./shipyard_2')
require('./shipyard_3')
require('./shipyard_4')
require('./transport_1')
require('./transport_2')
